import { useState } from "react";
import { motion } from "framer-motion";
import { Reveal, Overline } from "./Reveal";
import { JOURNEY } from "../data";

export const Timeline = () => {
  const [active, setActive] = useState(0);
  return (
    <section className="py-24 lg:py-32 bg-navy relative overflow-hidden" data-testid="timeline">
      <div className="absolute inset-0 grain" />
      <div className="max-w-7xl mx-auto px-6 relative">
        <div className="max-w-2xl mb-16">
          <Reveal><Overline dark>The Journey</Overline></Reveal>
          <Reveal delay={0.1}><h2 className="mt-5 font-display font-light text-4xl md:text-5xl tracking-tight text-white">From first flight to <span className="italic text-accent-2">airline flight deck</span>.</h2></Reveal>
        </div>
        <div className="grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <div className="relative pl-8">
              <div className="absolute left-[7px] top-2 bottom-2 w-px bg-white/15" />
              <motion.div className="absolute left-[7px] top-2 w-px bg-accent-c" animate={{ height: `${(active / (JOURNEY.length - 1)) * 100}%` }} transition={{ duration: 0.5 }} />
              {JOURNEY.map((j, i) => (
                <button key={j.step} onMouseEnter={() => setActive(i)} onClick={() => setActive(i)} data-testid={`timeline-step-${i}`} className="relative block text-left w-full py-4 group">
                  <span className={`absolute -left-8 top-6 h-3.5 w-3.5 rounded-full border-2 transition-colors duration-300 ${i <= active ? "bg-accent-c border-accent" : "bg-navy border-white/30"}`} />
                  <div className="flex items-baseline gap-3">
                    <span className={`font-display text-sm ${i === active ? "text-accent-2" : "text-white/40"}`}>{j.step}</span>
                    <span className={`font-display text-lg font-medium transition-colors ${i === active ? "text-white" : "text-white/55 group-hover:text-white/80"}`}>{j.title}</span>
                  </div>
                </button>
              ))}
            </div>
          </div>
          <div className="lg:col-span-7">
            <motion.div key={active} initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }} className="glass rounded-2xl p-10 h-full flex flex-col justify-center">
              <div className="font-display text-7xl md:text-8xl font-light text-accent-2 opacity-30">{JOURNEY[active].step}</div>
              <h3 className="mt-4 font-display text-3xl font-semibold text-white">{JOURNEY[active].title}</h3>
              <p className="mt-4 text-white/70 text-lg leading-relaxed">{JOURNEY[active].text}</p>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};
